import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Player Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Options of the video player
     */
    @Prop({ type: Object }) options!: {[k:string]: any};

    /**
     * Source of media file
     */
    @Prop({ type: String }) src!: string;

    /**
     * A flag for private media
     */
    @Prop({ type: Boolean }) isPrivate!: boolean;

    /**
     * Source of media preview
     */
    @Prop({ type: String, default: '' }) poster!: string;

    /**
     * hide controls for the player.
     */
    @Prop({ type: Boolean }) hideControls!: boolean;

    /**
     * Use iframe to display
     */
    @Prop({ type: Boolean }) iframe!: boolean;
    
    /**
     * Video file extensions
     */
    @Prop({ type: Array, default: () => ([]) }) videoExtensions!: Array<string>;

    /**
     * Audio file extensions
     */
    @Prop({ type: Array, default: () => ([]) }) audioExtensions!: Array<string>;

    /**
     * Type of media (e.g. video or audio)
     */
    @Prop({ type: String }) type!: string;

    /**
     * Show shift button on audio tag
     */
    @Prop({ type: Boolean }) shiftButton!: boolean;

    /**
     * Loading slug
     */
    @Prop({ type: String }) loadingOn!: string;
}

export default Props;
